import type { InputType } from 'config/input.type.constants'

export const sourceTypes: any = {
  hs_email: 'Hs_email',
  empty: '-',
}

export const campaignTypes: any = {
  adwords: 'Adwords',
  email: 'Email',
  empty: '-',
}

export const defaultInputs = (): Record<string, InputType> => {
  return {
    query: {
      inputType: 'text',
      title: 'Search',
    },
    source: {
      title: 'UTM_Source',
      inputType: 'select',
      hasDefaultOption: true,
      options: sourceTypes,
    },
    campaign: {
      title: 'UTM_Campaign',
      inputType: 'select',
      hasDefaultOption: true,
      options: campaignTypes,
    },
  }
}
